export default __webpack_public_path__ + "static/media/relative-bold-pro.5c45291e.eot";